import React from "react";
import "./App.css";
import Layout from "./components/Layout/Layout";
import AppRouter from "./components/Router/Router";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import InitializationApp from "./hocs/InitializationApp/InitializationApp";
import ToastsPortal from "./Portals/ToastsPortal";
import CookieConsent from "react-cookie-consent";
import { getTextByLanguage } from "./enums/utils/getTextByLanguage";
import { UXCookies } from "./enums/UXText/UXCookies";
import { useAppSelector } from "./hooks/redux";
import { getLanguage } from "./store/selectors/appSelector";

const App = () => {
	const language = useAppSelector(getLanguage);
	return (
		<BrowserRouter>
			<Layout>
				<AppRouter />
			</Layout>
			<ToastsPortal />
			<CookieConsent
				location='bottom'
				buttonText={getTextByLanguage(UXCookies.cookiesAcceptButton, language)}
				cookieName='cookiesAccept'
				style={{ background: "#EDEDED", color: "#000", display: "flex", alignItems: "center" }}
				buttonStyle={{
					backgroundColor: "#000",
					color: "#fff",
					borderRadius: "20px",
					fontWeight: "400",
					lineHeight: "21px",
					fontSize: "20px",
					border: "1,5px solid #000"
				}}
				expires={365}
			>
				{getTextByLanguage(UXCookies.cookiesMessage, language)}{" "}
				<a href='/cookies' style={{ color: "inherit" }}>
                {getTextByLanguage(UXCookies.cookiesMessageLink, language)}
				</a>
			</CookieConsent>
		</BrowserRouter>
	);
};

export default InitializationApp(App);
